import {
  BatchJobStatus,
  useAskSimulationAgentMutation,
} from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilCallback } from 'recoil';
import { aiAgentMessageById } from '../../aiAgent/store/aiAgent.state';
import useLoadAiQuery from '../../feed/hooks/useLoadAiQuery';
import { simulationCurrentId } from '../../simulation/store/simulation.state';

export type AskSimulationAgentParams = {
  question: string;
};

export function useAskSimulationAgent() {
  const { t } = useTranslation('errors');
  const errorTitle = t`Could not get response from Simulation AI Agent`;
  const [askSimulationAgent] = useAskSimulationAgentMutation();
  const [loadMessage, cancelLoadMessage] = useLoadAiQuery();
  let timeoutId = null;
  // const init = useRecoilCallback(
  //   ({ set, reset }) =>
  //     async (params: AskSimulationAgentParams) => {
  //       set(aiAgentMessageById(params.message.id), current => ({
  //         ...current,
  //         status: AsyncLoadStatus.Loading,
  //       }));
  //     },
  // );

  const handleError = useRecoilCallback(
    ({ snapshot, set }) =>
      async (messageId: string, details?: string, stack?: string) => {
        // set(errorAppender, {
        //   id: nanoid(),
        //   title: errorTitle,
        //   details: details,
        //   callStack: stack,
        // });
        set(aiAgentMessageById(messageId), current => ({
          ...current,
          status: BatchJobStatus.FAILED,
        }));
        return;
      },
  );

  const createAiAgentQuery = useRecoilCallback(
    ({ snapshot, set }) =>
      async (params: AskSimulationAgentParams) => {
        const simulationId = await snapshot.getPromise(simulationCurrentId);

        try {
          const { data: queryAiResponse, errors: queryAiError } =
            await askSimulationAgent({
              variables: {
                simulationId: simulationId,
                query: params.question,

                options: {
                  // architecture: AiQueryArchitecture.SUPERVISOR,
                  executeQuery: true,
                  sqlGeneratorPromptSettings: {
                    includeTableComments: true,
                    includeColumnComments: true,
                    includePossibleEnumValues: true,
                  },
                },
                context: {},
              },
            });

          if (!_.isEmpty(queryAiError)) {
            const details = _(queryAiError)
              .map(j => j.message)
              .join(';');
            handleError(details);
            return;
          }
          const aiQuery = queryAiResponse.createSimulationAiQuery;
          set(aiAgentMessageById(aiQuery.id), aiQuery);

          loadMessage({ id: aiQuery.id });
        } catch (ex) {
          handleError(ex?.message ?? ex);
        }
      },
  );

  async function ask(params: AskSimulationAgentParams) {
    // await init(params);
    await createAiAgentQuery(params);
  }

  return [ask /*cancel,*/] as const;
}
